module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 2.40861","quantity":0.02409},{"color":"#9dc4b5","label":" 2.40861- 3.33867","quantity":0.03339},{"color":"#e6efc3","label":" 3.33867- 4.26426","quantity":0.04264},{"color":"#ffe89e","label":" 4.26426- 5.4488","quantity":0.05449},{"color":"#f5af7f","label":" 5.4488- 7.29905","quantity":0.07299},{"color":"#ed6d32","label":" 7.29905- 23.53842","quantity":0.23538}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_90_return_10.json
// module id = 259D
// module chunks = 171